import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSparkleEmojiSecondary from './svgs/SparkleEmojiSecondary.js';
import SvgSparkleEmoji from './svgs/SparkleEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var sparkleEmoji = (props => useIcon(SvgSparkleEmoji, SvgSparkleEmojiSecondary, props));

export { sparkleEmoji as default };
